import React, { useState } from 'react';

import OriginalDriverCushioningInputs from '../inputs/OriginalDriverCushioningInputs';
import ParallelRideInputs from '../inputs/ParallelRideInputs';

import styles from './ParallelRideWithCushionStep.module.css';

/**
 * Leaf step for the parallel-ride branch when the reason is `busFailure` or
 * `driverOutOfHours`. Renders the ride picker plus explicit original-driver
 * cushioning parameters (Travelling start / Travelling end) through the
 * shared `<OriginalDriverCushioningInputs>` so the group-level validation
 * (start < incident, end < start) works out of the box.
 *
 * `outboundTraveling` is emitted from the explicit inputs — not derived from
 * the ride, unlike `ParallelRideStep`. Emits
 * `{ parallelRideId, outboundTraveling: { fromTimestamp, toTimestamp } }`.
 *
 * @param {import('common/activeElements/modals/FlowModal/flowTypes').FlowNodeComponentProps} props
 */
const ParallelRideWithCushionStep = ({ data, onDraftChange }) => {
	const [parallelRideId, setParallelRideId] = useState(data?.parallelRideId ?? null);
	const [parallelRide, setParallelRide] = useState(data?.parallelRide ?? null);
	const [outboundTraveling, setOutboundTraveling] = useState({
		fromTimestamp: data?.outboundTraveling?.fromTimestamp ?? '',
		toTimestamp: data?.outboundTraveling?.toTimestamp ?? '',
	});

	const emitChange = (nextRideId, nextRide, nextOutbound) => {
		onDraftChange?.({
			parallelRideId: nextRideId,
			parallelRide: nextRide,
			outboundTraveling: nextOutbound,
		});
	};

	const handleRideChange = (nextId, ride) => {
		setParallelRideId(nextId);
		setParallelRide(ride ?? null);
		emitChange(nextId, ride ?? null, outboundTraveling);
	};

	const handleOutboundChange = (nextOutbound) => {
		setOutboundTraveling(nextOutbound);
		emitChange(parallelRideId, parallelRide, nextOutbound);
	};

	return (
		<div className={styles.stack}>
			<ParallelRideInputs
				value={parallelRideId}
				onChange={handleRideChange}
				incidentTimestamp={data?.incidentTimestamp}
			/>

			<OriginalDriverCushioningInputs
				value={outboundTraveling}
				incidentTimestamp={data?.incidentTimestamp}
				onChange={handleOutboundChange}
			/>
		</div>
	);
};

export default ParallelRideWithCushionStep;
